import { makeRoute } from '~/utils/route';

export default makeRoute({
	path: '/admin/batch',
	template: '<batch-route></batch-route>',
	title: 'menu.batch',
});
